import { Outlet, useNavigate } from 'react-router-dom';
import { MAPBOX_MAP_CONTAINER } from 'constants/map';
import { appRoutes } from 'constants/routes';
import { useEscapeDown } from 'hooks/useEscapeDown';
import { useTouchTargetNoMove } from 'hooks/useTouchTargetNoMove';

import { ASIDE_WIDTH, SIDEBAR_WIDTH } from './constants';

export const SidebarBody = () => {
  const navigate = useNavigate();

  const mapContainer = document.getElementById(MAPBOX_MAP_CONTAINER);

  const onClose = () => navigate(appRoutes.MAP);

  useEscapeDown(onClose);

  useTouchTargetNoMove(onClose, mapContainer);

  return (
    <div
      className="absolute h-full z-[3] rounded-[10px]"
      style={{ left: ASIDE_WIDTH, width: SIDEBAR_WIDTH }}
    >
      <div className="w-full h-full p-1 rounded-[inherit]">
        <div className="relative w-full h-full rounded-[inherit] bg-dark">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
